module.exports = __webpack_public_path__ + "img/shape1.c4a654a7.png";